import { LazoPaths } from "@/enums/LazoPaths";
import i18n from "@/i18n/config";
import { AddOnModuleType, AddOnObjectKeyType } from "./AddOn";

export function getAddOnMap() {
  return {
    [AddOnModuleType.ACCOUNTING]: {
      [AddOnObjectKeyType.TAX_DUE_DATES]: {
        key: "Tax Deadlines",
        icon: <></>,
        label: i18n.t("navigation:drawer.items.taxDeadlines"),
        path: LazoPaths.TAX_DEADLINES,
      },
    },
    [AddOnModuleType.DATA_ROOM]: {
      [AddOnObjectKeyType.MASTER_DATA_ROOM]: {
        key: "data-room-master",
        icon: <></>,
        label: i18n.t("navigation:drawer.items.masterRoom"),
        path: LazoPaths.ONE_DATA_ROOM,
      },
    },
    [AddOnModuleType.VIEW_DATA_SHARED_BY_OTHERS]: {
      [AddOnObjectKeyType.SHARED_SPACES]: {
        key: "data-room-shared",
        icon: <></>,
        label: i18n.t("navigation:drawer.items.sharedSpaces"),
        path: LazoPaths.ONE_VIRTUAL_DATA_ROOMS,
      },
    },
  };
}
